import { authApi } from "./userApi";

const passwordApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    updatePassword: builder.mutation<
      { message: string },
      { current_password: string; new_password: string }
    >({
      query: (body) => ({
        url: "/users/profile/password",
        method: "POST",
        body,
      }),
      invalidatesTags: ["UserData"],
    }),
  }),
});

export const { useUpdatePasswordMutation } = passwordApi;
